import React from 'react';
import c from 'classnames';

import type { ImmutableEntity, Langcodes } from '@uncinc/react-drupal-core/types';

import Card from '../../../../components/Card';
import type { NodeRentalLocation } from '../../../../types/uncinc_profile/nodes';

interface NodeRentalLocationTeaserProps {
  entity: ImmutableEntity<NodeRentalLocation>;
}

const NodeRentalLocationTeaser: React.FC<NodeRentalLocationTeaserProps> = ({ entity }) => {
  const node = entity.toJS();
  // @TODO: Fix this typing in RDC.
  const language = node.langcode[0].value as Langcodes;
  const path = node.paths[language];
  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const image = node.field_media_item[0].styles.ratio_4_3_sm;
  const capacity = node.field_capacity[0].value;
  const classNames = c('NodeRentalLocation', 'NodeRentalLocation--Teaser');

  return (
    <Card
      className={classNames}
      link={path}
      label={capacity}
      title={title}
      body={body}
      image={image}
    />
  );
};

export default NodeRentalLocationTeaser;
